<script setup lang="ts">
import { onMounted } from 'vue';
import { getGoogleDriveUrl } from '~/utils';

interface Props
{
  compromisso?: any
  fluxo?: any
}

const props = defineProps<Props>();

const emit = defineEmits(['loaded']);

onMounted(() =>
{
  emit('loaded');
});
</script>

<template>
  <a-descriptions
    :column="3"
    bordered
  >
    <a-descriptions-item
      v-for="(data, index) in props.compromisso.data"
      :key="index"
      :span="3"
    >
      <span>{{ data.pastaCodigo }}</span> <span
        v-if="data.pastaNome"
        style="margin-left: 4px"
      >(<a

        :href="`/pasta/${data.pastaCodigo}`"
        target="_blank"
      >{{ data.pastaNome }}</a>)</span> -
      <a
        v-if="data.status === 'Sucesso'"
        :href="getGoogleDriveUrl(data.fileServiceId)"
        target="_blank"
      >{{ data.nome }}</a>
      <span v-else>{{ data.nome }}</span>
      <span v-if="data.referenciaGcpjNome"> - {{ data.referenciaGcpjNome }}</span>
      - {{ data.status }}
    </a-descriptions-item>
  </a-descriptions>
</template>
